// sideMenuData.js
export const sideMenuData = {
  1: {
    name: "Dashboard",
    icon: "fa-solid fa-gauge sidemenu-icon menu-icon",
    link: "/Dashboard",
    AccessCode: "",
  },
  2: {
    name: "Departments",
    icon: "fa-solid fa-building sidemenu-icon menu-icon",
    link: "/departments",
    AccessCode: "ADD-DEPT",
  },
  3: {
    name: "Suppliers",
    icon: "fa-solid fa-people-group sidemenu-icon menu-icon",
    link: "/suppliers",
    AccessCode: "VIEW-SUPPLIER",
  },
  4: {
    name: "Requisitions",
    icon: "fa-solid fa-file-contract sidemenu-icon menu-icon",
    link: "javascript:void(0)",
    AccessCode: "VIEW-REQUI",
    subMenu: [
      {
        name: "Add Requisition",
        icon: "",
        link: "/requsition/create",
        AccessCode: "ADD-REQUI",
      },
      {
        name: "Set Requisitions Approval Levels  ",
        icon: "",
        link: "/requisitions/View/set_approval_levels",
        AccessCode: "SET-APPROVAL_LV",
      },
      {
        name: "View Requisitions",
        icon: "",
        link: "/requisitions/View",
        AccessCode: "VIEW-REQUI",
      },
      {
        name: "View Requisitions WZ rejections",
        icon: "",
        link: "/requisitions/View/rejectedItems",
        AccessCode: "VIEW-REQUI",
      },
    ],
  },
  5: {
    name: "Approvals",
    icon: "fa-solid fa-clock sidemenu-icon menu-icon",
    link: "javascript:void(0)",
    AccessCode: "APPROVE-REQUI",
    subMenu: [
      {
        name: "Pending Approvals",
        icon: "",
        link: "/approvals/pending",
        AccessCode: "",
      },
      {
        name: "View Approvals",
        icon: "",
        link: "/approvals/view_my_approvals",
        AccessCode: "",
      },
    ],
  },
  6: {
    name: "Purchase Orders",
    icon: "fa-solid fa-cart-shopping sidemenu-icon menu-icon",
    link: "javascript:void(0)",
    AccessCode: "VIEW-ORDER",
    subMenu: [
      {
        name: "Create Purchase Order",
        icon: "",
        link: "/purchase_order/create",
        AccessCode: "ADD-ORDER",
      },
      {
        name: "View Purchase Orders",
        icon: "",
        link: "/purchase_orders/view_saved",
        AccessCode: "VIEW-ORDER",
      },
    ],
  },
  7: {
    name: "Delivery Notes",
    icon: "fa-solid fa-truck-fast sidemenu-icon menu-icon",
    link: "javascript:void(0)",
    AccessCode: "VIEW-DELIVERY",
    subMenu: [
      {
        name: "Create Delivery Notes",
        icon: "",
        link: "/delievery_notes/create",
        AccessCode: "ADD-SUPP-INVO",
      },
      {
        name: "View Delivery Notes",
        icon: "",
        link: "/delievery_notes/view",
        AccessCode: "VIEW-SUPP-INVO",
      },
    ],
  },
  8: {
    name: "Supplier Invoices",
    icon: "fa-solid fa-file-invoice sidemenu-icon menu-icon",
    link: "javascript:void(0)",
    AccessCode: "VIEW-SUPP-INVO",
    subMenu: [
      {
        name: "Create Supplier Invoice",
        icon: "",
        link: "/supplier_invoices/create",
        AccessCode: "ADD-SUPP-INVO",
      },
      {
        name: "View Supplier Invoices",
        icon: "",
        link: "/supplier_invoices/view",
        AccessCode: "VIEW-SUPP-INVO",
      },
      {
        name: "Invoice Not Fully Paid",
        icon: "",
        link: "/supplier_invoices/invoice_with_balances",
        AccessCode: "VIEW-SUPP-INVO",
      },
    ],
  },
  9: {
    name: "Payments",
    icon: "fa-solid fa-money-bill-transfer sidemenu-icon menu-icon",
    link: "javascript:void(0)",
    AccessCode: "VIEW-SUPP-PAY",
    subMenu: [
      {
        name: "Set Invoices 4 Payments",
        icon: "",
        link: "/supplier_invoices/Set_Invoices_4_Payments",
        // link: "/supplier_payment/pay",
        AccessCode: "ADD-SUPP-PAY",
      },
      {
        name: "confirm payments",
        icon: "",
        link: "/supplier_invoices/confirm_supplier_payments",
        AccessCode: "ADD-SUPP-PAY",
      },
      {
        name: "View Supplier Payments",
        icon: "",
        link: "/supplier_payment/view",
        AccessCode: "",
      },
    ],
  },
  10: {
    name: "System Users",
    icon: "fa-solid fa-users sidemenu-icon menu-icon",
    link: "javascript:void(0)",
    AccessCode: "VIEW-USER",
    subMenu: [
      {
        name: "Register User",
        icon: "",
        link: "/users/register_newbie",
        AccessCode: "ADD-USER",
      },
      {
        name: "View users",
        icon: "",
        link: "/users/View_users",
        AccessCode: "",
      },
      {
        name: "Roles",
        icon: "",
        link: "/users/roles",
        AccessCode: "",
      },
      {
        name: "Permissions",
        icon: "",
        link: "/users/permissions",
        AccessCode: "",
      },
    ],
  },
  11: {
    name: "Quotations",
    icon: "fa-solid fa-file-invoice-dollar sidemenu-icon menu-icon",
    link: "/suppliers/quotaions",
    AccessCode: "",
  },
};
